import React, { useEffect, useState } from 'react';
import { shippingApi } from '../services/api';

export default function Shipping() {
  const [orders, setOrders] = useState([]);
  const [loading, setLoading] = useState(true);
  const [trackingInputs, setTrackingInputs] = useState({});
  const [selected, setSelected] = useState(new Set());
  const [msg, setMsg] = useState('');

  function load() {
    setLoading(true);
    shippingApi.ready().then(setOrders).finally(() => setLoading(false));
  }
  useEffect(() => { load(); }, []);

  async function shipOne(id) {
    const tracking = trackingInputs[id] || '';
    await shippingApi.ship(id, tracking);
    setMsg(`Zásilka ${id} odeslána`);
    load();
  }

  async function shipSelected() {
    const shipments = [...selected].map(id => ({ order_id: id, tracking_number: trackingInputs[id] || '' }));
    await shippingApi.bulkShip(shipments);
    setMsg(`${shipments.length} zásilek označeno jako odeslaných`);
    setSelected(new Set());
    load();
  }

  function toggleSelect(id) {
    const s = new Set(selected);
    s.has(id) ? s.delete(id) : s.add(id);
    setSelected(s);
  }

  return (
    <div>
      <div className="page-header">
        <h1 className="page-title">🚚 Expedice</h1>
        <div style={{ display: 'flex', gap: 8 }}>
          {selected.size > 0 && (
            <button className="btn btn-success" onClick={shipSelected}>
              ✓ Odeslat vybrané ({selected.size})
            </button>
          )}
          <button className="btn btn-secondary" onClick={load}>🔄 Obnovit</button>
        </div>
      </div>

      {msg && <div className="alert alert-success">{msg}</div>}

      {loading && <div className="loading-center"><div className="spinner" /></div>}

      {!loading && orders.length === 0 && (
        <div className="empty-state">
          <div style={{ fontSize: 48, marginBottom: 10 }}>📭</div>
          <div>Žádné zásilky k expedici</div>
        </div>
      )}

      {orders.length > 0 && (
        <div className="card">
          <div className="card-header">
            <div className="card-title">Zásilky k odeslání ({orders.length})</div>
            <label style={{ fontSize: 13, cursor: 'pointer', display: 'flex', alignItems: 'center', gap: 6 }}>
              <input type="checkbox" onChange={e => setSelected(e.target.checked ? new Set(orders.map(o => o.id)) : new Set())} checked={selected.size === orders.length && orders.length > 0} />
              Vybrat vše
            </label>
          </div>
          <div className="table-wrap">
            <table>
              <thead>
                <tr>
                  <th style={{ width: 32 }}></th>
                  <th>Číslo</th>
                  <th>Zákazník</th>
                  <th>Adresa</th>
                  <th>Položky</th>
                  <th>Tracking číslo</th>
                  <th></th>
                </tr>
              </thead>
              <tbody>
                {orders.map(o => (
                  <tr key={o.id}>
                    <td>
                      <input type="checkbox" checked={selected.has(o.id)} onChange={() => toggleSelect(o.id)} />
                    </td>
                    <td style={{ fontWeight: 600 }}>{o.order_number}</td>
                    <td>
                      <div>{o.customer_name}</div>
                      <div style={{ fontSize: 11, color: 'var(--text-muted)' }}>{o.customer_phone}</div>
                    </td>
                    <td style={{ fontSize: 12 }}>{o.customer_address}, {o.customer_zip} {o.customer_city}</td>
                    <td style={{ fontSize: 12 }}>
                      {o.items?.map(i => <div key={i.id}>{i.quantity}× {i.product_name}</div>)}
                    </td>
                    <td>
                      <input className="form-control" style={{ width: 160 }} placeholder="XX0123456789CZ" value={trackingInputs[o.id] || ''} onChange={e => setTrackingInputs(t => ({...t, [o.id]: e.target.value}))} />
                    </td>
                    <td>
                      <button className="btn btn-success btn-sm" onClick={() => shipOne(o.id)}>
                        📤 Odeslat
                      </button>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>
      )}
    </div>
  );
}
